var hn = Object.defineProperty;
var pn = (e, t, n) => t in e ? hn(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var p = (e, t, n) => pn(e, typeof t != "symbol" ? t + "" : t, n);
import { Psbt as A, crypto as I, Transaction as ct, initEccLib as fn, payments as dn } from "bitcoinjs-lib";
import { Buffer as c } from "buffer";
import { HDKey as dt } from "@scure/bip32";
import { c as ta, a as ea, d as na, i as ra, r as oa } from "./testing-JbFsxz79.js";
import * as Pt from "@bitcoin-js/tiny-secp256k1-asmjs";
const x = 2147483648, En = 4294967295, ut = 86, yt = 0, Yt = 5, Oe = 3, gn = 3, _n = 4;
function Ut(e, t) {
  for (const n of t)
    if (!Number.isInteger(n) || n < 0 || n > En)
      throw new Error(`${e} levels must be integers in 0..0xffffffff`);
}
function X(e, t) {
  if (t.length !== Yt)
    throw new Error(`${e} must have exactly ${Yt} levels, got ${t.length}`);
  if (Ut(e, t), !t.slice(0, Oe).every((r) => (r & x) !== 0) || (t[_n] & x) !== 0)
    throw new Error(`${e} must harden purpose'/coin'/account' and leave the address index unhardened`);
  if (t[0] !== (x | ut) >>> 0)
    throw new Error(`${e} must use BIP-86 purpose ${ut}'`);
}
function M(e) {
  return "m/" + e.map((t) => (t & x) !== 0 ? `${(t & ~x) >>> 0}'` : `${t >>> 0}`).join("/");
}
const wn = /^[0-9a-f]{64}$/, Tn = /^[0-9a-f]{8}$/, mn = 192, $t = 32, Re = 1, In = 2, R = 32, Sn = 130, Pn = 135, yn = 136, An = 168, kt = 172, Bt = 173, xn = 178, bn = 81, ve = 128, Ht = 1, U = Ht + $t, On = 1 + $t + 1, Ce = 68, Ne = 34, Le = 67, Rn = 73, vn = 34, Cn = 35, Nn = 36, Ln = 37, Mn = 38, Un = 39, $n = 72, Xt = 90, Wt = 4032, kn = ve - 1;
function Bn(e) {
  const t = e.length;
  if (t <= Ce || e[0] !== R || e[U] !== Bt || e[t - 1] !== xn || e[Ne] !== R || e[Le] !== kt) return;
  const n = c.from(e.subarray(Ht, U)).toString("hex");
  if (e[t - 4] === In && (e[t - 2] & ve) === 0) {
    const r = e[t - 3] | e[t - 2] << 8;
    if (r >= Xt && r <= Wt)
      return { leafKeyHex: n };
  }
  if (e[t - 3] === Re) {
    const r = e[t - 2];
    if (r >= Xt && r <= Wt && r <= kn)
      return { leafKeyHex: n };
  }
}
const T = {
  claim: 0,
  wronglyChallenged: 0,
  payoutFinalize: 1,
  assert: 0,
  payoutDepositor: 0
}, Hn = 2, Dn = 0, Fn = 1, Vn = 2, Gn = 1, Kn = 1, Yn = 1, Xn = 2, Wn = 2, qn = 0;
function _t(e) {
  const t = e.tapLeafScript ?? [];
  if (!(t.length !== 1 || t[0].leafVersion !== mn))
    return t[0].script;
}
function zn(e) {
  return e.length === On && e[0] === R && e[U] === kt;
}
function jn(e) {
  return e.length === Rn && e[0] === R && e[U] === Bt && e[vn] === Sn && e[Cn] === Re && e[Nn] === $t && e[Ln] === yn && e[Mn] === An && e[Un] === R && e[$n] === Pn;
}
function Qn(e) {
  return e.length > Ce && e[0] === R && e[U] === Bt && e[Ne] === R && e[Le] === kt && e[e.length - 1] === bn;
}
function tt(e) {
  return c.from(e.subarray(Ht, U)).toString("hex");
}
function Zn(e, t) {
  let n;
  try {
    n = A.fromHex(e);
  } catch {
    return;
  }
  if (n.version < Hn || n.locktime !== Dn)
    return;
  const r = n.data.inputs.length, o = n.data.outputs.length;
  if (r === Xn && o === Wn) {
    const i = _t(n.data.inputs[T.payoutFinalize]);
    if (i === void 0) return;
    const a = Bn(i);
    if (a === void 0) return;
    const u = n.data.inputs[qn];
    if (t === T.payoutDepositor) {
      const l = _t(u);
      return l === void 0 || l[0] !== R || l.length <= U ? void 0 : {
        kind: "payoutDepositor",
        signInputIndex: T.payoutDepositor,
        leafKeyHex: tt(l)
      };
    }
    return t !== T.payoutFinalize || (u.tapLeafScript ?? []).length > 0 || (u.tapBip32Derivation ?? []).some((l) => l.pubkey.toString("hex") === a.leafKeyHex) ? void 0 : {
      kind: "payoutFinalize",
      signInputIndex: T.payoutFinalize,
      leafKeyHex: a.leafKeyHex
    };
  }
  if (t !== T.claim)
    return;
  const s = _t(n.data.inputs[T.claim]);
  if (s !== void 0) {
    if (r === Fn && o === Vn && zn(s))
      return { kind: "claim", signInputIndex: T.claim, leafKeyHex: tt(s) };
    if (r === Yn && Qn(s))
      return { kind: "assert", signInputIndex: T.assert, leafKeyHex: tt(s) };
    if (r === Gn && o === Kn && jn(s))
      return {
        kind: "wronglyChallenged",
        signInputIndex: T.wronglyChallenged,
        leafKeyHex: tt(s)
      };
  }
}
function Ci(e) {
  const { kind: t, psbtHex: n, depositorXOnlyHex: r, masterFingerprintHex: o, depositorPath: s } = e;
  if (!wn.test(r))
    throw new Error("depositorXOnlyHex must be 64 lowercase hex characters");
  if (!Tn.test(o))
    throw new Error("masterFingerprintHex must be 8 lowercase hex characters (the 4-byte master fingerprint)");
  if (X("depositorPath", s), t === "payoutDepositor")
    throw new Error(
      "payoutDepositor needs no derivation entry — the device takes its path from the intent; sign it through signPsbt"
    );
  const i = Zn(n, T[t]);
  if (i === void 0 || i.kind !== t)
    throw new Error(`not a ${t}-shaped PSBT for input ${T[t]}`);
  if (i.leafKeyHex !== r)
    throw new Error(`${t} leaf key does not equal the depositor key — this device cannot sign this PSBT`);
  const a = A.fromHex(n), u = a.data.inputs[i.signInputIndex];
  return u.tapBip32Derivation = void 0, a.updateInput(i.signInputIndex, {
    tapBip32Derivation: [
      {
        masterFingerprint: c.from(o, "hex"),
        pubkey: c.from(r, "hex"),
        path: M(s),
        leafHashes: []
      }
    ]
  }), a.toHex();
}
const Jn = 1, tr = 1, er = 1, nr = 2, rr = 33, or = 256, sr = 257, ir = 258, ar = 39, cr = 259, ur = 105, lr = 260, hr = 261, pr = 262, fr = 271, dr = 265, Er = 266, gr = 267, _r = 268, wr = 269, Tr = 270, mr = 263, Ir = 264, lt = 32, Sr = 32, z = 255, Pr = 3 + lt, qt = Math.floor(z / Pr);
function v(e, t) {
  if (t.length > z)
    throw new Error(`TLV value for tag 0x${e.toString(16)} exceeds 255 bytes`);
  const n = new Uint8Array(3 + t.length);
  return n[0] = e >> 8 & 255, n[1] = e & 255, n[2] = t.length, n.set(t, 3), n;
}
function Et(e, t, n) {
  if (e < 0n || e >= 1n << BigInt(8 * t))
    throw new Error(`${n} ${e} does not fit in ${t} bytes`);
  const r = new Uint8Array(t);
  let o = e;
  for (let s = t - 1; s >= 0; s--)
    r[s] = Number(o & 0xffn), o >>= 8n;
  return r;
}
function B(e, t, n) {
  return v(e, Et(BigInt(t), 1, n));
}
function et(e, t, n) {
  return v(e, Et(BigInt(t), 4, n));
}
function H(e, t, n) {
  return v(e, Et(t, 8, n));
}
function ht(e) {
  const t = e.reduce((o, s) => o + s.length, 0), n = new Uint8Array(t);
  let r = 0;
  for (const o of e)
    n.set(o, r), r += o.length;
  return n;
}
function Dt(e, t, n) {
  if (e.length !== t)
    throw new Error(`${n} must be ${t} bytes, got ${e.length}`);
  return e;
}
function yr(e) {
  X("depositorPath", e.depositorPath);
  const t = ht(e.depositorPath.map((n) => Et(BigInt(n), 4, "path level")));
  return ht([
    B(er, Jn, "structureType"),
    B(nr, tr, "version"),
    et(rr, e.coinType, "coinType"),
    H(or, e.baseFeeRate, "baseFeeRate"),
    et(sr, e.peginCsvTimelock, "peginCsvTimelock"),
    et(ir, e.payoutTimelock, "payoutTimelock"),
    v(ar, Dt(e.prepeginTxidInternal, Sr, "prepeginTxid")),
    et(cr, e.htlcRefundTimelock, "htlcRefundTimelock"),
    v(ur, t),
    B(lr, e.keeperCount, "keeperCount"),
    B(hr, e.challengerCount, "challengerCount"),
    B(pr, e.vaultCount, "vaultCount"),
    H(fr, e.prepeginMaxFee, "prepeginMaxFee")
  ]);
}
function Ar(e) {
  return ht([
    B(dr, e.htlcVout, "htlcVout"),
    v(Er, Dt(e.vaultProviderPubkey, lt, "vaultProviderPubkey")),
    H(gr, e.vaultAmount, "vaultAmount"),
    H(_r, e.commissionFee, "commissionFee"),
    H(wr, e.depositorClaimValue, "depositorClaimValue"),
    H(Tr, e.peginMaxFee, "peginMaxFee")
  ]);
}
function xr(e, t) {
  const n = (s, i) => s.map((a, u) => Dt(a, lt, `${i}[${u}]`)).sort((a, u) => {
    for (let l = 0; l < lt; l++)
      if (a[l] !== u[l]) return a[l] - u[l];
    return 0;
  }), r = [
    ...n(e, "keeper").map((s) => v(mr, s)),
    ...n(t, "challenger").map((s) => v(Ir, s))
  ], o = [];
  for (let s = 0; s < r.length; s += qt)
    o.push(ht(r.slice(s, s + qt)));
  return o;
}
const b = 225, wt = 128, zt = 129, br = 130, Or = 0, Rr = 1, vr = 0, Cr = 1, Nr = 2, j = 0, jt = 64, Qt = 1024, Zt = 10, Jt = 32, Lr = 0, Mr = 0, At = 4, Ur = 32, $r = 1;
function kr(e) {
  return new Uint8Array([e >> 8 & 255, e & 255]);
}
function Br(e) {
  return new Uint8Array([e >>> 24 & 255, e >>> 16 & 255, e >>> 8 & 255, e & 255]);
}
function it(e) {
  const t = new Uint8Array(e.reduce((r, o) => r + o.length, 0));
  let n = 0;
  for (const r of e)
    t.set(r, n), n += r.length;
  return t;
}
const te = /^[a-z0-9-]+$/;
async function Ni(e, { appName: t, derivationPath: n, context: r }) {
  const o = new TextEncoder().encode(t);
  if (o.length < 1 || o.length > jt)
    throw new Error(`appName must be 1..${jt} bytes, got ${o.length}`);
  if (!te.test(t))
    throw new Error(`appName must match ${te} — the device rejects other characters`);
  if (n.length < 1 || n.length > Zt)
    throw new Error(`derivationPath must have 1..${Zt} levels`);
  if (Ut("derivationPath", n), r.length < 1 || r.length > Qt)
    throw new Error(`context must be 1..${Qt} bytes, got ${r.length}`);
  const s = it([
    new Uint8Array([o.length]),
    o,
    new Uint8Array([n.length]),
    it(n.map(Br)),
    kr(r.length)
  ]), i = Math.min(r.length, z - s.length);
  if (i < 0)
    throw new Error("appName and derivationPath leave no room for context in the first APDU");
  let a = await e({
    cla: b,
    ins: zt,
    p1: Or,
    p2: j,
    data: it([s, r.subarray(0, i)])
  });
  for (let u = i; u < r.length; u += z)
    a = await e({
      cla: b,
      ins: zt,
      p1: Rr,
      p2: j,
      data: r.subarray(u, u + z)
    });
  if (a.length !== Jt)
    throw new Error(`Expected a ${Jt}-byte context root, got ${a.length} bytes`);
  return a;
}
function Hr(e) {
  return Uint8Array.from(I.sha256(c.from(it([...e]))).subarray(Ur - At));
}
function Me({ scalars: e, groups: t, keeperPubkeys: n, challengerPubkeys: r }) {
  return {
    scalars: yr(e),
    groups: t.map(Ar),
    keyBatches: xr(n, r)
  };
}
function Li(e) {
  const t = Me(e);
  return Hr([t.scalars, ...t.groups, ...t.keyBatches]);
}
async function Mi(e, t) {
  const { scalars: n, groups: r, keeperPubkeys: o, challengerPubkeys: s } = t;
  if (r.length !== n.vaultCount)
    throw new Error(`vaultCount ${n.vaultCount} does not match ${r.length} group(s)`);
  if (o.length !== n.keeperCount)
    throw new Error(`keeperCount ${n.keeperCount} does not match ${o.length} key(s)`);
  if (n.keeperCount < 1 || n.challengerCount < 1)
    throw new Error(
      `Both rosters must be non-empty: keeperCount=${n.keeperCount}, challengerCount=${n.challengerCount}`
    );
  if (s.length !== n.challengerCount)
    throw new Error(`challengerCount ${n.challengerCount} does not match ${s.length} key(s)`);
  const i = Me(t);
  await e({ cla: b, ins: wt, p1: vr, p2: j, data: i.scalars });
  for (const a of i.groups)
    await e({ cla: b, ins: wt, p1: Cr, p2: j, data: a });
  for (const a of i.keyBatches)
    await e({ cla: b, ins: wt, p1: Nr, p2: j, data: a });
}
function ee(e, t) {
  if (t >= e.length) throw new Error("GET_VAULT_STATE response is truncated");
  const n = e[t], r = t + $r;
  if (n === 0) return { fingerprint: void 0, next: r };
  if (n !== At)
    throw new Error(`GET_VAULT_STATE fingerprint length must be 0 or ${At}, got ${n}`);
  if (r + n > e.length) throw new Error("GET_VAULT_STATE response is truncated");
  return { fingerprint: e.slice(r, r + n), next: r + n };
}
async function Ui(e) {
  const t = await e({
    cla: b,
    ins: br,
    p1: Lr,
    p2: Mr,
    data: new Uint8Array(0)
  }), n = ee(t, 0), r = ee(t, n.next);
  if (r.next !== t.length) throw new Error("GET_VAULT_STATE response has trailing bytes");
  if (n.fingerprint === void 0 && r.fingerprint === void 0) return { phase: "idle" };
  if (n.fingerprint === void 0 && r.fingerprint !== void 0)
    return { phase: "hash-derived", contextFingerprint: r.fingerprint };
  if (n.fingerprint !== void 0 && r.fingerprint !== void 0)
    return { phase: "intent-loaded", intentFingerprint: n.fingerprint, contextFingerprint: r.fingerprint };
  throw new Error("GET_VAULT_STATE reported an intent without a context root");
}
const Dr = 0, Ue = 0, $e = 1, Fr = 0, ne = 33, re = 10, Vr = 5, Gr = 4;
async function $i(e) {
  const t = await e({
    cla: b,
    ins: Vr,
    p1: Ue,
    p2: $e,
    data: new Uint8Array(0)
  });
  if (t.length !== Gr)
    throw new Error(`Ledger returned a ${t.length}-byte response instead of the 4-byte master fingerprint`);
  return ke(t);
}
async function Kr(e, t, n) {
  if (t.length < 1 || t.length > re)
    throw new Error(`BIP-32 path must have 1..${re} levels, got ${t.length}`);
  Ut("BIP-32 path", t);
  const r = await e({
    cla: b,
    ins: Dr,
    p1: Ue,
    p2: $e,
    data: Yr(t)
  }), o = new TextDecoder().decode(r);
  if (o.length === 0)
    throw new Error("Ledger returned an empty extended key");
  return dt.fromExtendedKey(o, n), o;
}
async function ki(e, t, n) {
  const r = await Kr(e, t, n), o = dt.fromExtendedKey(r, n);
  if (!o.publicKey || o.publicKey.length !== ne)
    throw new Error(`Ledger returned an extended key without a ${ne}-byte public key`);
  return ke(o.publicKey.subarray(1));
}
function ke(e) {
  return Array.from(e, (t) => t.toString(16).padStart(2, "0")).join("");
}
function Yr(e) {
  const t = new Uint8Array(2 + e.length * 4);
  return t[0] = Fr, t[1] = e.length, e.forEach((n, r) => {
    const o = 2 + r * 4;
    t[o] = n >>> 24 & 255, t[o + 1] = n >>> 16 & 255, t[o + 2] = n >>> 8 & 255, t[o + 3] = n & 255;
  }), t;
}
const Be = "LedgerUserRefusedError", He = "LedgerDeviceLockedError", De = "LedgerDeviceError", Fe = "LedgerYieldMismatchError", Ve = "LedgerSignPsbtIncompleteError", Ge = "LedgerSignPsbtProtocolError", Ke = "LedgerSignPsbtAbortedError";
function Ye(e) {
  return e.toString(16).padStart(4, "0");
}
class Xr extends Error {
  constructor(n) {
    super(`User rejected the request on the Ledger device (0x${Ye(n)})`);
    p(this, "statusWord");
    this.name = Be, this.statusWord = n;
  }
}
class Wr extends Error {
  constructor(n, r) {
    super(`The Ledger device is locked — unlock it and retry (0x${Ye(n)})`);
    p(this, "statusWord");
    /**
     * true only when the sign loop proved the refused APDU was the initial
     * SIGN_PSBT (no round ran). false = unproven — a CONTINUE after earlier
     * rounds, or any other exchange — so the adapter must assume the worst.
     */
    p(this, "preDispatch");
    this.name = He, this.statusWord = n, this.preDispatch = (r == null ? void 0 : r.preDispatch) ?? !1;
  }
}
class qr extends Error {
  constructor(n, r) {
    super(r);
    p(this, "statusWord");
    this.name = De, this.statusWord = n;
  }
}
class y extends Error {
  constructor(n, r) {
    super(
      `The device yielded a signature that fails the expected-signature table (${n}${r === void 0 ? "" : ` on input ${r}`})`
    );
    p(this, "kind");
    p(this, "inputIndex");
    this.name = Fe, this.kind = n, this.inputIndex = r;
  }
}
class zr extends Error {
  constructor(n) {
    super(
      `The device completed SIGN_PSBT without yielding every expected signature (missing ${n.length}: ${n.join(", ")})`
    );
    /** Missing (input, leaf) units: `"i:leafHex"` for tapscript, `"i"` for keypath. */
    p(this, "missing");
    this.name = Ve, this.missing = n;
  }
}
function at(e) {
  return e.map(
    ({ inputIndex: t, leafHashHex: n }) => n === void 0 ? { inputIndex: t } : { inputIndex: t, leafHashHex: n }
  );
}
class d extends Error {
  constructor(n, r = []) {
    super(`SIGN_PSBT protocol failure: ${n}`);
    p(this, "detail");
    /**
     * Which yields the device had already delivered when the failure hit, by
     * identity only (see {@link CollectedYieldRef}); empty for prepare-time
     * rejections, which run before any device I/O. Diagnostics only — nothing in
     * this package reads them, and whether a failed ceremony burns the device
     * signatures is unresolved, so there is no retry or resume path here.
     */
    p(this, "collectedYields");
    this.name = Ge, this.detail = n, this.collectedYields = r;
  }
}
class oe extends Error {
  constructor(n) {
    super("SIGN_PSBT was abandoned host-side before completion");
    /** Yields the device had already delivered when the host stopped sending. */
    p(this, "yieldedCount");
    this.name = Ke, this.yieldedCount = n;
  }
}
function Bi(e) {
  return e instanceof Error && e.name === Be;
}
function Hi(e) {
  return e instanceof Error && e.name === De;
}
function Di(e) {
  return e instanceof Error && e.name === He;
}
function jr(e) {
  return e instanceof Error && e.name === Fe;
}
function Fi(e) {
  return e instanceof Error && e.name === Ve;
}
function Qr(e) {
  return e instanceof Error && e.name === Ge;
}
function Vi(e) {
  return e instanceof Error && e.name === Ke;
}
const Zr = 36864, Jr = /* @__PURE__ */ new Set([21761, 27013]), to = /* @__PURE__ */ new Set([21781, 27010, 21251]), Xe = 28160, We = 27904, eo = 45063, no = 45066, ro = {
  27264: "The device rejected the data as invalid",
  // SW_NOT_SUPPORTED — for the silent key read this usually means the app
  // build (mainnet vs testnet coin type) does not match the selected network.
  27266: "The device does not support this request — check that the app build matches the selected network",
  27270: "The device rejected the instruction parameters",
  27271: "The device rejected the payload length",
  [We]: "The running app does not support this instruction",
  // SWO_COMMAND_NOT_ACCEPTED (`sdk:include/status_words.h:56`) — sent by the SDK
  // IO layer before dispatch, so the app never ran the command: from the UX
  // heartbeat when an APDU lands mid-approval (`sdk:io_legacy/src/os_io_legacy.c:132`,
  // already in v26.6.0) and, new in v26.6.1, when a command arrives while a
  // reply is still pending (`:400-412`).
  // Retry advice omitted on purpose: a 0x6901 currently takes the provider's
  // pessimistic reset, so retrying fails until #2530 keeps the intent.
  26881: "The device was still busy with the previous request",
  // Network-agnostic on purpose: the app is "Babylon Vault" on mainnet and
  // "Babylon Vault Testnet" on test networks (dmkSession.readAppAndVersion).
  [Xe]: "The running app does not handle vault instructions — open the Babylon Vault app for this network",
  45056: "The device reported a wrong response length",
  [eo]: "The device is not in the expected state for this step",
  45064: "The device rejected a signature or HMAC as invalid",
  45065: "The device rejected the CPFP anchor",
  [no]: "The device has already signed the maximum number of these transactions",
  // SW_BIP32_FAIL: in the vault app only derive_context_hash.c and
  // approve_vault_intent.c send it.
  28416: "The device could not derive the key at the requested path"
};
function D(e) {
  return e.toString(16).padStart(2, "0");
}
function qe(e) {
  return e.toString(16).padStart(4, "0");
}
function ze(e, t) {
  if (e === Zr)
    return;
  if (Jr.has(e))
    return new Xr(e);
  if (to.has(e))
    return new Wr(e, { preDispatch: t.preDispatch === !0 });
  const n = ro[e], r = (e === Xe || e === We) && t.appName ? ` (app at connect time: "${t.appName}"${t.appVersion ? ` v${t.appVersion}` : ""})` : "";
  return new qr(
    e,
    `${n ?? "The device rejected the request"} (ins 0x${D(t.ins)} p1 0x${D(t.p1)}, sw 0x${qe(e)})${r}`
  );
}
function oo(e, t) {
  return async (n) => {
    const { sw: r, data: o } = await e(n), s = ze(r, { ...t, ins: n.ins, p1: n.p1 });
    if (s) throw s;
    return o;
  };
}
const se = 2;
function so(e) {
  if (e.statusCode.length !== se)
    throw new Error(
      `The device returned a ${e.statusCode.length}-byte status word; expected ${se}.`
    );
  return e.statusCode[0] << 8 | e.statusCode[1];
}
function nt(e, t) {
  if (!Number.isInteger(e) || e < 0 || e > 255)
    throw new Error(`APDU ${t} ${e} is not a single byte (0..255)`);
}
function io(e) {
  if (nt(e.cla, "cla"), nt(e.ins, "ins"), nt(e.p1, "p1"), nt(e.p2, "p2"), e.data.length > 255)
    throw new Error(`APDU data is ${e.data.length} bytes; Lc is a single byte (max 255)`);
  const t = new Uint8Array(5 + e.data.length);
  return t[0] = e.cla, t[1] = e.ins, t[2] = e.p1, t[3] = e.p2, t[4] = e.data.length, t.set(e.data, 5), t;
}
function ie() {
  return globalThis.__LEDGER_VAULT_APDU_TRACE__ === !0;
}
function ao(e) {
  return async (t) => {
    const n = `${D(t.cla)} ${D(t.ins)} ${D(t.p1)} ${D(t.p2)} Lc=${t.data.length}`;
    let r;
    try {
      r = await e.dmk.sendApdu({
        sessionId: e.sessionId,
        apdu: io(t)
      });
    } catch (s) {
      throw ie() && console.debug(`[ledger-vault] APDU ${n} -> transport error`, s), s;
    }
    const o = so(r);
    return ie() && console.debug(`[ledger-vault] APDU ${n} -> sw=0x${qe(o)} len=${r.data.length}`), { sw: o, data: r.data };
  };
}
function Gi(e) {
  return oo(ao(e), {
    appName: e.appName,
    appVersion: e.appVersion
  });
}
const co = 1, uo = 1, ae = 32, lo = 10, ce = 10000n, ue = 100000000n, pt = 72, ho = 1008, po = 4320, fo = 91, Eo = 4031, je = 546n, le = je, go = 2n, _o = "DepositTermsRejectedError";
class S extends Error {
  constructor(n, r = "device-envelope") {
    super(n);
    p(this, "reason");
    this.name = _o, this.reason = r;
  }
}
const P = "Deposit terms outside the device-supported range";
function N(e, t, n, r) {
  if (!Number.isInteger(t) || t < n || t > r)
    throw new S(`${P}: ${e} ${t} not in [${n}, ${r}]`);
}
function Ki(e) {
  if (N(
    "vaultCoreVersion",
    e.vaultCoreVersion,
    co,
    uo
  ), e.protocolFeeRate < 1n || e.protocolFeeRate > ce)
    throw new S(
      `${P}: protocolFeeRate ${e.protocolFeeRate} not in [1, ${ce}]`
    );
  if (N(
    "timelockPegin",
    e.timelockPegin,
    pt,
    ho
  ), N(
    "timelockAssert",
    e.timelockAssert,
    fo,
    Eo
  ), N(
    "timelockRefund",
    e.timelockRefund,
    pt,
    po
  ), N("keeper count", e.vaultKeeperBtcPubkeys.length, 1, ae), N(
    "challenger count",
    e.universalChallengerBtcPubkeys.length,
    1,
    ae
  ), N("vault count", e.vaults.length, 1, lo), q("prepeginMaxFee", e.prepeginMaxFee), e.prepeginMaxFee < 1n || e.prepeginMaxFee > ue)
    throw new S(
      `${P}: prepeginMaxFee ${e.prepeginMaxFee} not in [1, ${ue}]`
    );
  let t = -1;
  for (const a of e.vaults) {
    if (!Number.isInteger(a.htlcVout) || a.htlcVout < 0 || a.htlcVout > 255)
      throw new S(`${P}: htlcVout ${a.htlcVout} not in [0, 255]`);
    if (a.htlcVout <= t)
      throw new S(
        `${P}: vault groups must be in strictly ascending htlcVout order; got ${a.htlcVout} after ${t}`
      );
    t = a.htlcVout;
  }
  const n = (a) => a.replace(/^0x/, "").toLowerCase(), r = new Set(e.vaults.map((a) => n(a.vaultProviderBtcPubkey))), o = /* @__PURE__ */ new Set();
  for (const [a, u] of [
    ["vaultKeeperBtcPubkeys", e.vaultKeeperBtcPubkeys],
    ["universalChallengerBtcPubkeys", e.universalChallengerBtcPubkeys]
  ])
    for (const l of u) {
      const f = n(l);
      if (r.has(f))
        throw new S(
          `${P}: ${a} contains the vault provider's own key (${f.slice(0, 16)}…)`
        );
      if (o.has(f))
        throw new S(
          `${P}: duplicate participant key in ${a} (${f.slice(0, 16)}…)`
        );
      o.add(f);
    }
  const s = je, i = go * s;
  for (const a of e.vaults) {
    if (q(`vault ${a.htlcVout} peginAmount`, a.peginAmount), q(`vault ${a.htlcVout} commissionFee`, a.commissionFee), q(`vault ${a.htlcVout} depositorClaimValue`, a.depositorClaimValue), q(`vault ${a.htlcVout} peginMaxFee`, a.peginMaxFee), a.commissionFee < s)
      throw new S(
        `${P}: vault ${a.htlcVout} commissionFee ${a.commissionFee} below the ${s}-sat dust limit`
      );
    if (a.depositorClaimValue < le)
      throw new S(
        `${P}: vault ${a.htlcVout} depositorClaimValue ${a.depositorClaimValue} below the ${le}-sat device floor`
      );
    if (a.peginAmount <= a.commissionFee + i)
      throw new S(
        `${P}: vault ${a.htlcVout} peginAmount ${a.peginAmount} must exceed commissionFee + ${i} (${a.commissionFee + i})`
      );
  }
}
const wo = (1n << 64n) - 1n;
function q(e, t) {
  if (t < 0n || t > wo)
    throw new S(`${P}: ${e} ${t} does not fit in an unsigned 64-bit field`);
}
const To = /^[0-9a-f]{64}$/;
function mo(e, t) {
  if (X("depositorPath", e), e[gn] !== yt)
    throw new Error("depositorPath must use BIP-86 receive branch 0");
  for (let n = 0; n < Oe; n++)
    if (e[n] !== t[n])
      throw new Error(
        `depositorPath ${M(e)} is not under the wallet policy's key origin ${M(t)} — the device could never mark the input internal`
      );
}
function Yi(e, t, n) {
  if (!Number.isInteger(n) || n < 0 || n >= x)
    throw new Error("addressIndex must be a non-hardened integer in 0..2^31-1");
  const r = dt.fromExtendedKey(e, t).deriveChild(yt).deriveChild(n);
  if (!r.publicKey) throw new Error(`account xpub derived no public key at ${yt}/${n}`);
  return c.from(r.publicKey.subarray(1)).toString("hex");
}
function Xi(e) {
  const { psbtHex: t, depositorXOnlyHex: n, walletPolicy: r, depositorPath: o } = e;
  if (!To.test(n)) throw new Error("depositorXOnlyHex must be 64 lowercase hex characters");
  mo(o, r.keyOriginPath);
  const s = A.fromHex(t), i = c.from(r.masterFingerprintHex, "hex"), a = c.from(n, "hex");
  let u = 0;
  if (s.data.inputs.forEach((l, f) => {
    l.tapInternalKey && c.from(l.tapInternalKey).equals(a) && (u++, s.updateInput(f, {
      tapBip32Derivation: [
        {
          masterFingerprint: i,
          pubkey: a,
          path: M(o),
          leafHashes: []
        }
      ]
    }));
  }), u !== s.data.inputs.length)
    throw new Error(
      `${s.data.inputs.length - u} of ${s.data.inputs.length} inputs do not carry the depositor key as TAP_INTERNAL_KEY — every Pre-PegIn input must be internal`
    );
  return s.toHex();
}
const he = 253, Io = 254, So = 65535, Po = 4294967295;
function yo(e) {
  if (e < he)
    return c.from([e]);
  if (e <= So) {
    const t = c.alloc(2);
    return t.writeUInt16LE(e), c.concat([c.from([he]), t]);
  }
  if (e <= Po) {
    const t = c.alloc(4);
    return t.writeUInt32LE(e), c.concat([c.from([Io]), t]);
  }
  throw new Error(`Script too large to encode as CompactSize: ${e} bytes`);
}
const Ao = "TapLeaf";
function xo(e, t) {
  const n = c.concat([c.from([e]), yo(t.length), c.from(t)]);
  return I.taggedHash(Ao, n);
}
function bo(e, t, n, r) {
  for (let o = 0; o < t; o++) {
    if (n[o + r] === void 0)
      throw Error("Buffer too small");
    n[o + r] = Number(e % BigInt(256)), e = e >> BigInt(8);
  }
}
function Oo(e, t, n) {
  let r = BigInt(0);
  for (let o = 0; o < n; o++) {
    const s = e[o + t];
    if (s === void 0)
      throw Error("Buffer too small");
    r += BigInt(s) << BigInt(o * 8);
  }
  return r;
}
function O(e) {
  if (e < 0) throw RangeError("Negative bigint is not a valid varint");
  if (e > Number.MAX_SAFE_INTEGER) throw RangeError("Too large for a Number");
  return Number(e);
}
function Ro(e) {
  if (typeof e == "number" && (e = O(e)), e < BigInt(0))
    throw new RangeError("Negative numbers are not supported");
  if (e >= BigInt(1) << BigInt(64))
    throw new RangeError("Too large for a Bitcoin-style varint");
  return e < BigInt(253) ? 1 : e <= BigInt(65535) ? 3 : e <= BigInt(4294967295) ? 5 : 9;
}
const vo = BigInt(253), Co = BigInt(65535) + BigInt(1), No = BigInt(4294967295) + BigInt(1);
function Qe(e, t) {
  if (t < 0)
    throw RangeError("Negative offset is invalid");
  const n = e[t];
  if (n === void 0)
    throw Error("Buffer too small");
  if (n < 253)
    return [BigInt(n), 1];
  {
    let r, o;
    n === 253 ? (r = 2, o = vo) : n === 254 ? (r = 4, o = Co) : (r = 8, o = No);
    const s = Oo(e, t + 1, r);
    if (s < o)
      throw RangeError(
        `Non-minimal varint at offset ${t}: a ${r + 1}-byte CompactSize must encode a value of at least ${o}; re-encode it in its canonical (shorter) form`
      );
    return [s, r + 1];
  }
}
function V(e) {
  typeof e == "number" && (e = O(e));
  const t = Ro(e);
  e = BigInt(e);
  const n = c.alloc(t);
  return t == 1 ? n[0] = Number(e) : (t == 3 ? n[0] = 253 : t === 5 ? n[0] = 254 : n[0] = 255, bo(e, t - 1, n, 1)), n;
}
const Lo = 31;
function Ze(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error("Can't convert a number that is not a non-negative safe integer to 64-bit LE");
  const t = c.alloc(8, 0);
  for (let n = 0; n < t.length; n++) {
    const r = e & 255;
    t[n] = r, e = (e - r) / 256;
  }
  return t;
}
function xt(e) {
  let t = 0;
  if (e.length !== 8)
    throw new Error("Expected Buffer of length 8");
  if (e[7] !== 0)
    throw new Error("Can't encode numbers > MAX_SAFE_INT");
  const n = e[6];
  if (n === void 0 || n > Lo)
    throw new Error("Can't encode numbers > MAX_SAFE_INT");
  for (let r = e.length - 1; r >= 0; r--) {
    const o = e[r];
    if (o === void 0)
      throw new Error("Buffer too small");
    t = t * 256 + o;
  }
  return t;
}
class L {
  constructor() {
    p(this, "bufs", []);
  }
  write(t, n) {
    const r = c.alloc(t);
    n(r), this.bufs.push(r);
  }
  writeUInt8(t) {
    this.write(1, (n) => n.writeUInt8(t, 0));
  }
  writeInt32(t) {
    this.write(4, (n) => n.writeInt32LE(t, 0));
  }
  writeUInt32(t) {
    this.write(4, (n) => n.writeUInt32LE(t, 0));
  }
  writeUInt64(t) {
    const n = Ze(t);
    this.writeSlice(n);
  }
  writeVarInt(t) {
    this.bufs.push(V(t));
  }
  writeSlice(t) {
    this.bufs.push(c.from(t));
  }
  writeVarSlice(t) {
    this.writeVarInt(t.length), this.writeSlice(t);
  }
  buffer() {
    return c.concat(this.bufs);
  }
}
class F {
  constructor(t, n = 0) {
    this.buffer = t, this.offset = n;
  }
  available() {
    return this.buffer.length - this.offset;
  }
  readUInt8() {
    const t = this.buffer.readUInt8(this.offset);
    return this.offset++, t;
  }
  readInt32() {
    const t = this.buffer.readInt32LE(this.offset);
    return this.offset += 4, t;
  }
  readUInt32() {
    const t = this.buffer.readUInt32LE(this.offset);
    return this.offset += 4, t;
  }
  readUInt64() {
    const t = this.readSlice(8);
    return xt(t);
  }
  readVarInt() {
    const [t, n] = Qe(this.buffer, this.offset);
    return this.offset += n, t;
  }
  readSlice(t) {
    if (this.buffer.length < this.offset + t)
      throw new Error("Cannot read slice out of bounds");
    const n = this.buffer.subarray(this.offset, this.offset + t);
    return this.offset += t, n;
  }
  readVarSlice() {
    const t = O(this.readVarInt());
    return this.readSlice(t);
  }
  readVector() {
    const t = this.readVarInt(), n = [];
    for (let r = 0; r < t; r++) n.push(this.readVarSlice());
    return n;
  }
}
var bt = /* @__PURE__ */ ((e) => (e[e.NON_WITNESS_UTXO = 0] = "NON_WITNESS_UTXO", e[e.WITNESS_UTXO = 1] = "WITNESS_UTXO", e[e.PARTIAL_SIG = 2] = "PARTIAL_SIG", e[e.SIGHASH_TYPE = 3] = "SIGHASH_TYPE", e[e.REDEEM_SCRIPT = 4] = "REDEEM_SCRIPT", e[e.WITNESS_SCRIPT = 5] = "WITNESS_SCRIPT", e[e.BIP32_DERIVATION = 6] = "BIP32_DERIVATION", e[e.FINAL_SCRIPTSIG = 7] = "FINAL_SCRIPTSIG", e[e.FINAL_SCRIPTWITNESS = 8] = "FINAL_SCRIPTWITNESS", e[e.PREVIOUS_TXID = 14] = "PREVIOUS_TXID", e[e.OUTPUT_INDEX = 15] = "OUTPUT_INDEX", e[e.SEQUENCE = 16] = "SEQUENCE", e[e.TAP_KEY_SIG = 19] = "TAP_KEY_SIG", e[e.TAP_LEAF_SCRIPT = 21] = "TAP_LEAF_SCRIPT", e[e.TAP_BIP32_DERIVATION = 22] = "TAP_BIP32_DERIVATION", e[e.TAP_INTERNAL_KEY = 23] = "TAP_INTERNAL_KEY", e))(bt || {});
const pe = c.from([112, 115, 98, 116, 255]), Mo = 4294967295;
class Je extends Error {
}
class tn {
  constructor() {
    p(this, "globalMap", /* @__PURE__ */ new Map());
    p(this, "inputMaps", []);
    p(this, "outputMaps", []);
  }
  setGlobalTxVersion(t) {
    this.setGlobal(2, k(t));
  }
  getGlobalTxVersion() {
    return this.getGlobal(
      2
      /* TX_VERSION */
    ).readUInt32LE(0);
  }
  setGlobalFallbackLocktime(t) {
    this.setGlobal(3, k(t));
  }
  getGlobalFallbackLocktime() {
    var t;
    return (t = this.getGlobalOptional(
      3
      /* FALLBACK_LOCKTIME */
    )) == null ? void 0 : t.readUInt32LE(0);
  }
  setGlobalInputCount(t) {
    this.setGlobal(4, Ee(t));
  }
  getGlobalInputCount() {
    return ge(this.getGlobal(
      4
      /* INPUT_COUNT */
    ));
  }
  setGlobalOutputCount(t) {
    this.setGlobal(5, Ee(t));
  }
  getGlobalOutputCount() {
    return ge(this.getGlobal(
      5
      /* OUTPUT_COUNT */
    ));
  }
  setGlobalTxModifiable(t) {
    this.setGlobal(6, t);
  }
  getGlobalTxModifiable() {
    return this.getGlobalOptional(
      6
      /* TX_MODIFIABLE */
    );
  }
  setGlobalPsbtVersion(t) {
    this.setGlobal(251, k(t));
  }
  getGlobalPsbtVersion() {
    return this.getGlobal(
      251
      /* VERSION */
    ).readUInt32LE(0);
  }
  setInputNonWitnessUtxo(t, n) {
    this.setInput(t, 0, _(), n);
  }
  getInputNonWitnessUtxo(t) {
    return this.getInputOptional(t, 0, _());
  }
  setInputWitnessUtxo(t, n, r) {
    const o = new L();
    o.writeSlice(de(n)), o.writeVarSlice(r), this.setInput(t, 1, _(), o.buffer());
  }
  getInputWitnessUtxo(t) {
    const n = this.getInputOptional(t, 1, _());
    if (!n) return;
    const r = new F(n);
    return {
      amount: xt(r.readSlice(8)),
      scriptPubKey: r.readVarSlice()
    };
  }
  setInputPartialSig(t, n, r) {
    this.setInput(t, 2, n, r);
  }
  getInputPartialSig(t, n) {
    return this.getInputOptional(t, 2, n);
  }
  setInputSighashType(t, n) {
    this.setInput(t, 3, _(), k(n));
  }
  getInputSighashType(t) {
    const n = this.getInputOptional(t, 3, _());
    if (n)
      return n.readUInt32LE(0);
  }
  setInputRedeemScript(t, n) {
    this.setInput(t, 4, _(), n);
  }
  getInputRedeemScript(t) {
    return this.getInputOptional(t, 4, _());
  }
  setInputWitnessScript(t, n) {
    this.setInput(t, 5, _(), n);
  }
  getInputWitnessScript(t) {
    return this.getInputOptional(t, 5, _());
  }
  setInputBip32Derivation(t, n, r, o) {
    if (n.length !== 33) throw new Error("Invalid pubkey length: " + n.length);
    this.setInput(t, 6, n, this.encodeBip32Derivation(r, o));
  }
  getInputBip32Derivation(t, n) {
    const r = this.getInputOptional(t, 6, n);
    if (r)
      return this.decodeBip32Derivation(r);
  }
  setInputFinalScriptsig(t, n) {
    this.setInput(t, 7, _(), n);
  }
  getInputFinalScriptsig(t) {
    return this.getInputOptional(t, 7, _());
  }
  setInputFinalScriptwitness(t, n) {
    this.setInput(t, 8, _(), n);
  }
  getInputFinalScriptwitness(t) {
    return this.getInput(t, 8, _());
  }
  setInputPreviousTxId(t, n) {
    this.setInput(t, 14, _(), n);
  }
  getInputPreviousTxid(t) {
    return this.getInput(t, 14, _());
  }
  setInputOutputIndex(t, n) {
    this.setInput(t, 15, _(), k(n));
  }
  getInputOutputIndex(t) {
    return this.getInput(t, 15, _()).readUInt32LE(0);
  }
  setInputSequence(t, n) {
    this.setInput(t, 16, _(), k(n));
  }
  getInputSequence(t) {
    var n;
    return ((n = this.getInputOptional(t, 16, _())) == null ? void 0 : n.readUInt32LE(0)) ?? Mo;
  }
  setInputTapKeySig(t, n) {
    this.setInput(t, 19, _(), n);
  }
  getInputTapKeySig(t) {
    return this.getInputOptional(t, 19, _());
  }
  setInputTapBip32Derivation(t, n, r, o, s) {
    if (n.length !== 32) throw new Error("Invalid pubkey length: " + n.length);
    const i = this.encodeTapBip32Derivation(r, o, s);
    this.setInput(t, 22, n, i);
  }
  getInputTapBip32Derivation(t, n) {
    const r = this.getInput(t, 22, n);
    return this.decodeTapBip32Derivation(r);
  }
  getInputKeyDatas(t, n) {
    return this.getKeyDatas(this.inputMaps[t], n);
  }
  /** LOCAL ADDITION (vault expected-signature table): all entries of one key type. */
  getInputEntriesOfType(t, n) {
    const r = this.inputMaps[t];
    if (!r)
      throw new Error("No such map");
    const o = [];
    return r.forEach((s, i) => {
      this.isKeyType(i, [n]) && o.push({ keyData: c.from(i.substring(2), "hex"), value: c.from(s) });
    }), o;
  }
  setOutputRedeemScript(t, n) {
    this.setOutput(t, 0, _(), n);
  }
  getOutputRedeemScript(t) {
    return this.getOutput(t, 0, _());
  }
  setOutputBip32Derivation(t, n, r, o) {
    this.setOutput(t, 2, n, this.encodeBip32Derivation(r, o));
  }
  getOutputBip32Derivation(t, n) {
    const r = this.getOutput(t, 2, n);
    return this.decodeBip32Derivation(r);
  }
  setOutputAmount(t, n) {
    this.setOutput(t, 3, _(), de(n));
  }
  getOutputAmount(t) {
    const n = this.getOutput(t, 3, _());
    return xt(n);
  }
  setOutputScript(t, n) {
    this.setOutput(t, 4, _(), n);
  }
  getOutputScript(t) {
    return this.getOutput(t, 4, _());
  }
  setOutputTapBip32Derivation(t, n, r, o, s) {
    const i = this.encodeTapBip32Derivation(r, o, s);
    this.setOutput(t, 7, n, i);
  }
  getOutputTapBip32Derivation(t, n) {
    const r = this.getOutput(t, 7, n);
    return this.decodeTapBip32Derivation(r);
  }
  deleteInputEntries(t, n) {
    const r = this.inputMaps[t];
    if (!r)
      throw new Error("No such map");
    r.forEach((o, s, i) => {
      this.isKeyType(s, n) && i.delete(s);
    });
  }
  copy(t) {
    this.copyMap(this.globalMap, t.globalMap), this.copyMaps(this.inputMaps, t.inputMaps), this.copyMaps(this.outputMaps, t.outputMaps);
  }
  copyMaps(t, n) {
    t.forEach((r, o) => {
      const s = /* @__PURE__ */ new Map();
      this.copyMap(r, s), n[o] = s;
    });
  }
  copyMap(t, n) {
    t.forEach((r, o) => n.set(o, c.from(r)));
  }
  serialize() {
    const t = new L();
    return t.writeSlice(pe), mt(t, this.globalMap), this.inputMaps.forEach((n) => {
      mt(t, n);
    }), this.outputMaps.forEach((n) => {
      mt(t, n);
    }), t.buffer();
  }
  deserialize(t) {
    const n = new F(t);
    if (!n.readSlice(5).equals(pe))
      throw new Error("Invalid magic bytes");
    for (; this.readKeyPair(this.globalMap, n); ) ;
    let r;
    try {
      r = this.getGlobalPsbtVersion();
    } catch (i) {
      if (!(i instanceof Je))
        throw i;
      r = 0;
    }
    if (r !== 0 && r !== 2) throw new Error("Only PSBTs of version 0 or 2 are supported");
    let o, s;
    if (r === 0) {
      const i = this.getGlobal(
        0
        /* UNSIGNED_TX */
      ), a = ct.fromBuffer(i);
      o = a.ins.length, s = a.outs.length;
    } else
      o = this.getGlobalInputCount(), s = this.getGlobalOutputCount();
    for (let i = 0; i < o; i++) {
      const a = /* @__PURE__ */ new Map();
      for (this.inputMaps[i] = a; this.readKeyPair(a, n); ) ;
    }
    for (let i = 0; i < s; i++) {
      const a = /* @__PURE__ */ new Map();
      for (this.outputMaps[i] = a; this.readKeyPair(a, n); ) ;
    }
    if (n.available() !== 0)
      throw new Error("Trailing bytes after PSBT output maps");
    this.normalizeToV2();
  }
  normalizeToV2() {
    var o;
    const t = (o = this.getGlobalOptional(
      251
      /* VERSION */
    )) == null ? void 0 : o.readUInt32LE(0);
    if (t === 2) return;
    if (t !== void 0)
      throw new Error("Invalid or unsupported value for PSBT_GLOBAL_VERSION");
    const n = this.getGlobal(
      0
      /* UNSIGNED_TX */
    ), r = ct.fromBuffer(n);
    this.setGlobalPsbtVersion(2), this.setGlobalTxVersion(r.version), this.setGlobalFallbackLocktime(r.locktime), this.setGlobalInputCount(r.ins.length), this.setGlobalOutputCount(r.outs.length), r.ins.forEach((s, i) => {
      this.setInputPreviousTxId(i, s.hash), this.setInputOutputIndex(i, s.index), this.setInputSequence(i, s.sequence);
    }), r.outs.forEach((s, i) => {
      this.setOutputAmount(i, s.value), this.setOutputScript(i, s.script);
    }), this.globalMap.delete("0".padStart(2, "0"));
  }
  readKeyPair(t, n) {
    const r = O(n.readVarInt());
    if (r === 0)
      return !1;
    const o = n.readUInt8(), s = n.readSlice(r - 1), i = n.readVarSlice(), a = new G(o, s).toString();
    if (t.has(a))
      throw new Error("Repeated keypair in PSBT map");
    return t.set(a, i), !0;
  }
  getKeyDatas(t, n) {
    if (!t)
      throw new Error("No such map");
    const r = [];
    return t.forEach((o, s) => {
      this.isKeyType(s, [n]) && r.push(c.from(s.substring(2), "hex"));
    }), r;
  }
  isKeyType(t, n) {
    const r = c.from(t.substring(0, 2), "hex").readUInt8(0);
    return n.some((o) => o === r);
  }
  setGlobal(t, n) {
    const r = new G(t, c.from([]));
    this.globalMap.set(r.toString(), n);
  }
  getGlobal(t) {
    return Tt(this.globalMap, t, _());
  }
  getGlobalOptional(t) {
    return Ot(this.globalMap, t, _());
  }
  setInput(t, n, r, o) {
    fe(this.getMap(t, this.inputMaps), n, r, o);
  }
  getInput(t, n, r) {
    return Tt(this.inputMaps[t], n, r);
  }
  getInputOptional(t, n, r) {
    return Ot(this.inputMaps[t], n, r);
  }
  setOutput(t, n, r, o) {
    fe(this.getMap(t, this.outputMaps), n, r, o);
  }
  getOutput(t, n, r) {
    return Tt(this.outputMaps[t], n, r);
  }
  getMap(t, n) {
    const r = n[t];
    if (r)
      return r;
    const o = /* @__PURE__ */ new Map();
    return n[t] = o, o;
  }
  encodeBip32Derivation(t, n) {
    const r = new L();
    return this.writeBip32Derivation(r, t, n), r.buffer();
  }
  decodeBip32Derivation(t) {
    const n = new F(t);
    return this.readBip32Derivation(n);
  }
  writeBip32Derivation(t, n, r) {
    t.writeSlice(n), r.forEach((o) => {
      t.writeUInt32(o);
    });
  }
  readBip32Derivation(t) {
    const n = t.readSlice(4), r = [];
    for (; t.offset < t.buffer.length; )
      r.push(t.readUInt32());
    return { masterFingerprint: n, path: r };
  }
  encodeTapBip32Derivation(t, n, r) {
    const o = new L();
    return o.writeVarInt(t.length), t.forEach((s) => {
      o.writeSlice(s);
    }), this.writeBip32Derivation(o, n, r), o.buffer();
  }
  decodeTapBip32Derivation(t) {
    const n = new F(t), r = O(n.readVarInt()), o = [];
    for (let i = 0; i < r; i++)
      o.push(n.readSlice(32));
    const s = this.readBip32Derivation(n);
    return { hashes: o, ...s };
  }
}
function Tt(e, t, n) {
  const r = Ot(e, t, n);
  if (r === void 0)
    throw new Je(new G(t, n).toString());
  return r;
}
function Ot(e, t, n) {
  if (!e)
    throw new Error("No such map");
  const r = new G(t, n), o = e.get(r.toString());
  if (o !== void 0)
    return c.from(o);
}
class G {
  constructor(t, n) {
    p(this, "keyType");
    p(this, "keyData");
    this.keyType = t, this.keyData = n;
  }
  toString() {
    const t = new L();
    return this.toBuffer(t), t.buffer().toString("hex");
  }
  serialize(t) {
    t.writeVarInt(1 + this.keyData.length), this.toBuffer(t);
  }
  toBuffer(t) {
    t.writeUInt8(this.keyType), t.writeSlice(this.keyData);
  }
}
class Uo {
  constructor(t, n) {
    p(this, "key");
    p(this, "value");
    this.key = t, this.value = n;
  }
  serialize(t) {
    this.key.serialize(t), t.writeVarSlice(this.value);
  }
}
function $o(e) {
  return new G(e.readUInt8(0), e.subarray(1));
}
function mt(e, t) {
  const n = [...t].sort(([r], [o]) => r < o ? -1 : r > o ? 1 : 0);
  for (const [r, o] of n)
    new Uo($o(c.from(r, "hex")), o).serialize(e);
  e.writeUInt8(0);
}
function _() {
  return c.from([]);
}
function fe(e, t, n, r) {
  const o = new G(t, n);
  e.set(o.toString(), r);
}
function k(e) {
  const t = c.alloc(4);
  return t.writeUInt32LE(e, 0), t;
}
function de(e) {
  return Ze(e);
}
function Ee(e) {
  const t = new L();
  return t.writeVarInt(e), t.buffer();
}
function ge(e) {
  return O(new F(e).readVarInt());
}
const _e = 192, Rt = 32, we = 2, rt = 33, ot = 32, ko = 1, Bo = "TapBranch", Ho = "TapTweak", Te = 64, me = 32, It = 64, Do = 34, ft = c.from([81, 32]), Fo = c.from([0, 20]), Vo = 2, Go = 3;
function Ft(e) {
  fn(Pt);
  const t = dn.p2tr({ internalPubkey: c.from(e, "hex") }).output;
  if (!t)
    throw new d("p2tr produced no output script for the depositor key");
  return t;
}
function Ie(e, t) {
  const n = c.concat([c.from([t]), c.from(e, "hex")]);
  return c.concat([Fo, I.hash160(n)]);
}
function en(e) {
  return e.length === Do && e.subarray(0, ft.length).equals(ft);
}
function Ko(e, t, n, r) {
  if (!en(r))
    throw new d(`input ${e} is tapscript but its witnessUtxo script is not P2TR`);
  const o = t.length - rt;
  if (o < 0 || o % ot !== 0)
    throw new d(
      `input ${e} control block length ${t.length} is not ${rt} plus a multiple of ${ot}`
    );
  const s = t.subarray(1, rt);
  if (!Pt.isXOnlyPoint(s))
    throw new d(`input ${e} control block internal key is not an x-only point`);
  let i = n;
  for (let f = rt; f < t.length; f += ot) {
    const E = t.subarray(f, f + ot), h = c.compare(i, E) < 0 ? [i, E] : [E, i];
    i = I.taggedHash(Bo, c.concat(h));
  }
  const a = I.taggedHash(Ho, c.concat([s, i])), u = Pt.xOnlyPointAddTweak(s, a);
  if (!u)
    throw new d(`input ${e} control block internal key has no taproot output key`);
  if (!r.subarray(ft.length).equals(c.from(u.xOnlyPubkey)))
    throw new d(
      `input ${e} control block does not commit to its TAP_LEAF_SCRIPT (recomputed taproot output key differs from the witnessUtxo witness program)`
    );
  if (u.parity !== (t[0] & ko))
    throw new d(
      `input ${e} control block parity bit disagrees with the recomputed taproot output key`
    );
}
function Yo(e) {
  const { psbt: t, depositorXOnlyHex: n, signInputIndexes: r } = e, o = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), i = t.getGlobalInputCount(), a = r === void 0 ? void 0 : new Set(r), u = (h) => a === void 0 || a.has(h);
  if ((a == null ? void 0 : a.size) === 0)
    throw new d(
      "signInputIndexes is empty — pass the indices to sign, or omit it to sign every device-signable input"
    );
  for (const h of a ?? [])
    if (!Number.isInteger(h) || h < 0 || h >= i)
      throw new d(
        `input ${h} was requested for signing but this PSBT has ${i} input(s)`
      );
  const l = Ft(n), f = [
    Ie(n, Vo),
    Ie(n, Go)
  ];
  for (let h = 0; h < i; h++) {
    const g = t.getInputEntriesOfType(h, bt.TAP_LEAF_SCRIPT);
    if (g.length > 0) {
      if (g.length > 1)
        throw new d(
          `input ${h} carries an ambiguous leaf set (${g.length} TAP_LEAF_SCRIPT entries)`
        );
      const w = g[0].value;
      if (w.length < we)
        throw new d(
          `input ${h} TAP_LEAF_SCRIPT value length ${w.length} is below the ${we}-byte minimum (script byte plus the leaf-version byte)`
        );
      const W = w[w.length - 1];
      if (W !== _e)
        throw new d(
          `input ${h} leaf version 0x${W.toString(16)} is not tapscript (0xc0)`
        );
      const $ = t.getInputWitnessUtxo(h);
      if (!$)
        throw new d(`input ${h} is tapscript but has no witnessUtxo`);
      const J = w.subarray(0, w.length - 1), Gt = xo(_e, J);
      Ko(h, g[0].keyData, Gt, $.scriptPubKey);
      const Kt = {
        kind: "tapscript",
        expectedLeafHashHexes: /* @__PURE__ */ new Set([Gt.toString("hex")]),
        expectedSignerXOnlyHex: n
      };
      s.set(h, Kt), u(h) && o.set(h, Kt);
      continue;
    }
    const C = t.getInputEntriesOfType(h, bt.TAP_INTERNAL_KEY);
    if (C.length > 0) {
      const w = C[0];
      if (C.length > 1 || w.keyData.length !== 0 || w.value.length !== Rt)
        throw new d(`input ${h} carries a malformed TAP_INTERNAL_KEY entry`);
      if (w.value.toString("hex") !== n)
        throw new d(`input ${h} internal key is not the connected depositor key`);
      const W = t.getInputWitnessUtxo(h);
      if (!W)
        throw new d(`input ${h} is keypath but has no witnessUtxo`);
      const $ = W.scriptPubKey;
      if (!en($))
        throw new d(`input ${h} witnessUtxo script is not P2TR`);
      if (!$.equals(l))
        throw new d(
          `input ${h} witnessUtxo is not the BIP-86 P2TR of the depositor key`
        );
      const J = {
        kind: "taproot-keypath",
        expectedOutputKeyHex: $.subarray(ft.length).toString("hex")
      };
      s.set(h, J), o.set(h, J);
      continue;
    }
    const gt = t.getInputWitnessUtxo(h);
    if (gt && (gt.scriptPubKey.equals(l) || f.some((w) => gt.scriptPubKey.equals(w))))
      throw new d(
        `input ${h} spends a depositor-owned UTXO but carries no signing metadata`
      );
  }
  for (const h of a ?? [])
    if (!o.has(h))
      throw new d(
        `input ${h} was requested for signing but carries no signing metadata`
      );
  if (o.size === 0)
    throw new d("PSBT contains no depositor-signable input");
  let E = 0;
  for (const h of o.values())
    E += h.kind === "tapscript" ? h.expectedLeafHashHexes.size : 1;
  return { byInput: o, classifiedByInput: s, expectedYieldCount: E };
}
function st(e) {
  return e.kind === "tapscript" ? `${e.inputIndex}:${e.leafHashHex}` : `${e.inputIndex}`;
}
function Se(e, t) {
  if (e < It)
    throw new d(
      `YIELD payload truncated inside the signature (${e} of ${It} bytes on input ${t})`
    );
  if (e !== It)
    throw new y("non-default-sighash", t);
}
function Xo(e) {
  const t = [], n = /* @__PURE__ */ new Set();
  return {
    assertAndRecord: (s) => {
      let i, a;
      try {
        const [f, E] = Qe(s, 0);
        i = O(f), a = E;
      } catch (f) {
        throw new d(
          `unparseable YIELD payload: ${f instanceof Error ? f.message : String(f)}`
        );
      }
      const u = s[a];
      if (u === void 0)
        throw new d("YIELD payload truncated before the augmented-pubkey length");
      const l = e.byInput.get(i);
      if (l === void 0)
        throw new y("unexpected-input", i);
      if (u === Te) {
        if (l.kind !== "tapscript")
          throw new y("wrong-spend-type", i);
        const f = a + 1 + Te;
        if (s.length < f)
          throw new d("YIELD payload truncated inside the augmented pubkey");
        const E = s.subarray(a + 1, a + 1 + Rt).toString("hex"), h = s.subarray(a + 1 + Rt, f).toString("hex"), g = s.subarray(f);
        if (E !== l.expectedSignerXOnlyHex)
          throw new y("wrong-signer-key", i);
        if (!l.expectedLeafHashHexes.has(h))
          throw new y("unknown-leaf-hash", i);
        Se(g.length, i);
        const C = {
          kind: "tapscript",
          inputIndex: i,
          signerXOnlyHex: E,
          leafHashHex: h,
          signature: Uint8Array.from(g)
        };
        if (n.has(st(C)))
          throw new y("duplicate-yield", i);
        n.add(st(C)), t.push(C);
        return;
      }
      if (u === me) {
        if (l.kind !== "taproot-keypath")
          throw new y("wrong-spend-type", i);
        const f = a + 1 + me;
        if (s.length < f)
          throw new d("YIELD payload truncated inside the augmented pubkey");
        const E = s.subarray(a + 1, f).toString("hex"), h = s.subarray(f);
        if (E !== l.expectedOutputKeyHex)
          throw new y("wrong-signer-key", i);
        Se(h.length, i);
        const g = {
          kind: "taproot-keypath",
          inputIndex: i,
          outputKeyHex: E,
          signature: Uint8Array.from(h)
        };
        if (n.has(st(g)))
          throw new y("duplicate-yield", i);
        n.add(st(g)), t.push(g);
        return;
      }
      throw new y("unexpected-encoding", i);
    },
    get yields() {
      return t;
    },
    get lastYield() {
      return t[t.length - 1];
    },
    assertComplete: () => {
      const s = /* @__PURE__ */ new Set();
      for (const [u, l] of e.byInput)
        if (l.kind === "tapscript")
          for (const f of l.expectedLeafHashHexes)
            s.add(`${u}:${f}`);
        else
          s.add(`${u}`);
      const i = [...s].filter((u) => !n.has(u)), a = [...n].some((u) => !s.has(u));
      if (i.length > 0 || a || n.size !== e.expectedYieldCount)
        throw new zr(i);
    }
  };
}
const Wo = "BIP0322-signed-message", qo = new Uint8Array([252, 6, 98, 118, 97, 117, 108, 116, 0]), nn = 0, rn = 0, on = 0, zo = 0, vt = 0, jo = c.from([106]), Qo = /^[0-9a-f]{64}$/, Zo = /^[0-9a-f]{8}$/, Jo = c.alloc(32, 0), ts = 4294967295, es = c.from([0, 32]), ns = c.from([81, 32]), rs = 2;
function os(e, t) {
  const n = I.sha256(c.from(e, "utf8"));
  return I.sha256(c.concat([n, n, c.from(t)]));
}
function ss(e, t) {
  const n = new ct();
  n.version = nn, n.locktime = rn;
  const r = c.concat([es, os(Wo, e)]);
  return n.addInput(Jo, ts, on, r), n.addOutput(c.concat([ns, c.from(t)]), vt), Uint8Array.from(n.getHash(!1));
}
function Wi(e) {
  const { message: t, depositorXOnlyHex: n, masterFingerprintHex: r, depositorPath: o } = e;
  if (!Qo.test(n))
    throw new Error("depositorXOnlyHex must be 64 lowercase hex characters");
  if (!Zo.test(r))
    throw new Error("masterFingerprintHex must be 8 lowercase hex characters");
  X("depositorPath", o);
  const s = new TextEncoder().encode(t), i = c.from(n, "hex"), a = Ft(n), u = ss(s, a.subarray(rs)), l = new A();
  return l.setVersion(nn), l.setLocktime(rn), l.addInput({
    // A Buffer hash is used as-is (internal/wire order) — no reversal.
    hash: c.from(u),
    index: zo,
    sequence: on,
    witnessUtxo: { script: a, value: vt },
    tapInternalKey: i,
    tapBip32Derivation: [
      {
        masterFingerprint: c.from(r, "hex"),
        pubkey: i,
        path: M(o),
        leafHashes: []
      }
    ]
  }), l.addOutput({ script: jo, value: vt }), l.addUnknownKeyValToGlobal({ key: c.from(qo), value: c.from(s) }), l.toHex();
}
const is = /^[0-9a-f]{64}$/, as = /^[0-9a-f]{8}$/, cs = 192, Ct = 32, us = 0, ls = 1, hs = 32, ps = 75, fs = 76, ds = 79, Es = 80, gs = 81, _s = 96, ws = 173, Ts = 178, Pe = 4, ye = 128, ms = 1 + Ct + 1 + 1 + 1, Is = 2, Ss = 34, Ps = 2147483648, ys = 4194304, As = 65535, xs = 2, bs = 0, Os = 0;
function Rs(e) {
  if (e.length < ms) return;
  let t = 0;
  if (e[t++] !== hs) return;
  const n = c.from(e.subarray(t, t + Ct)).toString("hex");
  if (t += Ct, e[t++] !== ws || t >= e.length) return;
  const r = e[t++];
  let o = 0;
  if (!(r === us || r === ds)) {
    if (r >= ls && r <= ps) {
      const s = r;
      if (s > Pe || t + s > e.length || (e[t + s - 1] & ye) !== 0) return;
      for (let i = 0; i < s; i++) o |= e[t + i] << 8 * i;
      t += s;
    } else if (r === fs) {
      if (t >= e.length) return;
      const s = e[t++];
      if (s > Pe || t + s > e.length || (e[t + s - 1] & ye) !== 0) return;
      for (let i = 0; i < s; i++) o |= e[t + i] << 8 * i;
      t += s;
    } else if (r >= gs && r <= _s)
      o = r - Es;
    else
      return;
    if (!(o === 0 || o > As) && !(t >= e.length) && e[t++] === Ts && t === e.length)
      return { leafKeyHex: n, csv: o };
  }
}
function vs(e) {
  let t;
  try {
    t = A.fromHex(e);
  } catch {
    return;
  }
  if (t.version < xs || t.locktime !== bs || t.data.inputs.length !== 1 || t.data.outputs.length !== 1) return;
  const n = t.data.inputs[0], r = n.tapLeafScript ?? [];
  if (r.length !== 1 || r[0].leafVersion !== cs) return;
  const o = Rs(r[0].script);
  if (o !== void 0)
    return {
      ...o,
      inputTxidInternalHex: c.from(t.txInputs[0].hash).toString("hex"),
      sequence: t.txInputs[0].sequence ?? 0,
      sighashType: n.sighashType,
      witnessUtxo: n.witnessUtxo ? { scriptLength: n.witnessUtxo.script.length, value: n.witnessUtxo.value } : void 0,
      outputScriptHex: c.from(t.txOutputs[0].script).toString("hex"),
      outputValue: t.txOutputs[0].value
    };
}
function Cs(e) {
  if (e.sighashType !== void 0 && e.sighashType !== Os)
    throw new Error(
      `refund input sighash type ${e.sighashType} must be absent or SIGHASH_DEFAULT — the device rejects any other value`
    );
  if (e.witnessUtxo === void 0 || e.witnessUtxo.scriptLength !== Ss)
    throw new Error(
      "refund input must carry a P2TR witnessUtxo — the device rejects a missing or non-34-byte scriptPubKey"
    );
  if (e.outputValue > e.witnessUtxo.value)
    throw new Error(
      `refund output value ${e.outputValue} exceeds the HTLC value ${e.witnessUtxo.value} — the device rejects it`
    );
  if (e.outputScriptHex !== Ft(e.leafKeyHex).toString("hex"))
    throw new Error("refund output does not pay the refund leaf key's own BIP-86 address");
  if (e.csv < pt)
    throw new Error(
      `refund leaf CSV ${e.csv} is below the device's timelock floor of ${pt} blocks`
    );
  if ((e.sequence & Ps) !== 0 || (e.sequence & ys) !== 0)
    throw new Error(
      "refund input sequence must be a plain block-count relative timelock (BIP-68 disable/time flags clear)"
    );
  if (e.sequence !== e.csv)
    throw new Error(
      `refund input sequence ${e.sequence} must equal the leaf CSV ${e.csv} — the device compares them unmasked and rejects a mismatch`
    );
}
function qi(e) {
  const { psbtHex: t, depositorXOnlyHex: n, masterFingerprintHex: r, depositorPath: o } = e;
  if (!is.test(n))
    throw new Error("depositorXOnlyHex must be 64 lowercase hex characters");
  if (!as.test(r))
    throw new Error("masterFingerprintHex must be 8 lowercase hex characters (the 4-byte master fingerprint)");
  X("depositorPath", o);
  const s = vs(t);
  if (s === void 0)
    throw new Error("not a refund-shaped PSBT (expected 1 input, 1 output, and one refund tapscript leaf)");
  if (Cs(s), s.leafKeyHex !== n)
    throw new Error("refund leaf key does not equal the depositor key — this device cannot sign this refund");
  const i = A.fromHex(t), a = c.from(i.txOutputs[0].script), u = c.from(r, "hex"), l = M(o);
  return i.updateInput(0, {
    tapBip32Derivation: [
      {
        masterFingerprint: u,
        pubkey: c.from(n, "hex"),
        path: l,
        leafHashes: []
      }
    ]
  }), i.updateOutput(0, {
    tapBip32Derivation: [
      {
        masterFingerprint: u,
        // The BIP-86 TWEAKED key, verbatim from the scriptPubKey — the device
        // looks the entry up by these exact bytes, then derives at `path`,
        // applies the BIP-86 tweak and compares (`fw:sign_psbt_validate.c:1025-1069`).
        // BIP-371 permits the output key as the map key ("It may be the output
        // key, the internal key, or a key present in a leaf script").
        pubkey: a.subarray(Is),
        path: l,
        leafHashes: []
      }
    ]
  }), i.toHex();
}
const Ns = /^[0-9a-f]{64}$/, Ls = /^[0-9a-f]{8}$/, Ms = 192, Us = 32, $s = 32, ks = 172, sn = 1, Nt = sn + Us, Bs = Nt + 1, Hs = 2, Ds = 0, Fs = 1, Vs = 1, Lt = 0;
function Gs(e) {
  let t;
  try {
    t = A.fromHex(e);
  } catch {
    return;
  }
  if (t.version < Hs || t.locktime !== Ds || t.data.inputs.length !== Fs || t.data.outputs.length !== Vs)
    return;
  const n = t.data.inputs[Lt].tapLeafScript ?? [];
  if (n.length !== 1 || n[0].leafVersion !== Ms) return;
  const r = n[0].script;
  if (!(r.length !== Bs || r[0] !== $s || r[Nt] !== ks))
    return { leafKeyHex: c.from(r.subarray(sn, Nt)).toString("hex") };
}
function zi(e) {
  const { psbtHex: t, depositorXOnlyHex: n, masterFingerprintHex: r, depositorPath: o } = e;
  if (!Ns.test(n))
    throw new Error("depositorXOnlyHex must be 64 lowercase hex characters");
  if (!Ls.test(r))
    throw new Error("masterFingerprintHex must be 8 lowercase hex characters (the 4-byte master fingerprint)");
  X("depositorPath", o);
  const s = Gs(t);
  if (s === void 0) throw new Error("not a Reclaim-shaped PSBT");
  if (s.leafKeyHex !== n)
    throw new Error("Reclaim leaf key does not equal the depositor key — this device cannot sign this PSBT");
  const i = A.fromHex(t);
  return i.data.inputs[Lt].tapBip32Derivation = void 0, i.updateInput(Lt, {
    tapBip32Derivation: [
      {
        masterFingerprint: c.from(r, "hex"),
        pubkey: c.from(n, "hex"),
        path: M(o),
        leafHashes: []
      }
    ]
  }), i.toHex();
}
class K {
  constructor(t, n = I.sha256) {
    p(this, "leaves");
    p(this, "rootNode");
    p(this, "leafNodes");
    p(this, "h");
    this.leaves = t, this.h = n;
    const r = this.calculateRoot(t);
    this.rootNode = r.root, this.leafNodes = r.leaves;
  }
  getRoot() {
    return this.rootNode.hash;
  }
  size() {
    return this.leaves.length;
  }
  getLeaves() {
    return this.leaves;
  }
  getLeafHash(t) {
    const n = this.leafNodes[t];
    if (n === void 0) throw Error("Index out of bounds");
    return n.hash;
  }
  getProof(t) {
    const n = this.leafNodes[t];
    if (n === void 0) throw Error("Index out of bounds");
    return Mt(n);
  }
  calculateRoot(t) {
    const n = t.length;
    if (n == 0)
      return {
        root: new St(void 0, void 0, c.alloc(32, 0)),
        leaves: []
      };
    if (n == 1) {
      const f = new St(void 0, void 0, t[0]);
      return { root: f, leaves: [f] };
    }
    const r = Ys(n), o = this.calculateRoot(t.slice(0, r)), s = this.calculateRoot(t.slice(r)), i = o.root, a = s.root, u = this.hashNode(i.hash, a.hash), l = new St(i, a, u);
    return i.parent = l, a.parent = l, { root: l, leaves: o.leaves.concat(s.leaves) };
  }
  hashNode(t, n) {
    return this.h(c.concat([c.from([1]), t, n]));
  }
}
function Y(e, t = I.sha256) {
  return Ks(c.from([0]), e, t);
}
function Ks(e, t, n) {
  return n(c.concat([e, t]));
}
class St {
  constructor(t, n, r) {
    p(this, "leftChild");
    p(this, "rightChild");
    p(this, "parent");
    p(this, "hash");
    this.leftChild = t, this.rightChild = n, this.hash = r;
  }
  isLeaf() {
    return this.leftChild == null;
  }
}
function Mt(e) {
  if (!e.parent)
    return [];
  if (e.parent.leftChild == e) {
    if (!e.parent.rightChild)
      throw new Error("Expected right child to exist");
    return [e.parent.rightChild.hash, ...Mt(e.parent)];
  } else {
    if (!e.parent.leftChild)
      throw new Error("Expected left child to exist");
    return [e.parent.leftChild.hash, ...Mt(e.parent)];
  }
}
function Ys(e) {
  if (e < 2)
    throw Error("Expected n >= 2");
  return Xs(e) ? e / 2 : 1 << Math.floor(Math.log2(e));
}
function Xs(e) {
  return (e & e - 1) == 0;
}
const Vt = 255, Ws = 2, m = 32;
class Z {
}
class qs extends Z {
  constructor(n, r, o) {
    super();
    p(this, "results");
    p(this, "code", 16);
    this.progressCallback = r, this.onYield = o, this.results = n;
  }
  execute(n) {
    const r = c.from(n.subarray(1));
    return this.onYield && this.onYield(c.from(r)), this.results.push(r), this.progressCallback && this.progressCallback(), c.from("");
  }
}
class zs extends Z {
  constructor(n, r) {
    super();
    p(this, "knownPreimages");
    p(this, "queue");
    p(this, "code", 64);
    this.knownPreimages = n, this.queue = r;
  }
  execute(n) {
    const r = c.from(n.subarray(1));
    if (r.length !== 1 + m)
      throw new Error("Invalid request, unexpected trailing data");
    if (r[0] !== 0)
      throw new Error("Unsupported request, the first byte should be 0");
    const s = c.from(r.subarray(1, 1 + m)).toString("hex"), i = this.knownPreimages.get(s);
    if (i !== void 0) {
      const a = V(i.length), u = Vt - a.length - 1, l = Math.min(u, i.length);
      if (l < i.length)
        for (let f = l; f < i.length; f++)
          this.queue.push(c.from(i.subarray(f, f + 1)));
      return c.concat([
        a,
        c.from([l]),
        c.from(i.subarray(0, l))
      ]);
    }
    throw new Error(`Requested unknown preimage for: ${s}`);
  }
}
class js extends Z {
  constructor(n, r) {
    super();
    p(this, "knownTrees");
    p(this, "queue");
    p(this, "code", 65);
    this.knownTrees = n, this.queue = r;
  }
  execute(n) {
    const r = c.from(n.subarray(1));
    if (r.length < m + 1 + 1)
      throw new Error("Invalid request, expected at least 34 bytes");
    const o = new F(r), i = o.readSlice(m).toString("hex");
    let a, u;
    try {
      a = O(o.readVarInt()), u = O(o.readVarInt());
    } catch {
      throw new Error("Invalid request, couldn't parse tree_size or leaf_index");
    }
    const l = this.knownTrees.get(i);
    if (!l)
      throw new Error(`Requested Merkle leaf proof for unknown tree: ${i}`);
    if (u >= a || l.size() !== a)
      throw new Error("Invalid index or tree size.");
    if (this.queue.length !== 0)
      throw new Error("This command should not execute when the queue is not empty.");
    const f = l.getProof(u), E = Math.min(
      Math.floor((Vt - m - 1 - 1) / m),
      f.length
    ), h = f.length - E;
    return h > 0 && this.queue.push(...f.slice(-h)), c.concat([
      l.getLeafHash(u),
      c.from([f.length]),
      c.from([E]),
      ...f.slice(0, E)
    ]);
  }
}
class Qs extends Z {
  constructor(n) {
    super();
    p(this, "knownTrees");
    p(this, "code", 66);
    this.knownTrees = n;
  }
  execute(n) {
    const r = c.from(n.subarray(1));
    if (r.length !== m + m)
      throw new Error("Invalid request, unexpected trailing data");
    const s = c.from(r.subarray(0, m)).toString("hex"), a = c.from(r.subarray(m, m + m)).toString("hex"), u = this.knownTrees.get(s);
    if (!u)
      throw new Error(`Requested Merkle leaf index for unknown root: ${s}`);
    let l = 0, f = 0;
    for (let E = 0; E < u.size(); E++)
      if (u.getLeafHash(E).toString("hex") === a) {
        f = 1, l = E;
        break;
      }
    return c.concat([c.from([f]), V(l)]);
  }
}
class Zs extends Z {
  constructor(n) {
    super();
    p(this, "queue");
    p(this, "code", 160);
    this.queue = n;
  }
  execute(n) {
    if (n.length !== 1)
      throw new Error("Invalid request, unexpected trailing data");
    const r = this.queue[0];
    if (r === void 0)
      throw new Error("No elements to get");
    const o = r.length;
    if (this.queue.some((u) => u.length !== o))
      throw new Error("The queue contains elements with different byte length, which is not expected");
    const s = Math.floor((Vt - Ws) / o), i = Math.min(s, this.queue.length), a = this.queue.splice(0, i);
    return c.concat([c.from([i]), c.from([o]), ...a]);
  }
}
class Js {
  constructor(t, n) {
    p(this, "roots", /* @__PURE__ */ new Map());
    p(this, "preimages", /* @__PURE__ */ new Map());
    p(this, "yielded", []);
    p(this, "queue", []);
    p(this, "commands", /* @__PURE__ */ new Map());
    const r = [
      new qs(this.yielded, t, n),
      new zs(this.preimages, this.queue),
      new Qs(this.roots),
      new js(this.roots, this.queue),
      new Zs(this.queue)
    ];
    for (const o of r) {
      if (this.commands.has(o.code))
        throw new Error(`Multiple commands with code ${o.code}`);
      this.commands.set(o.code, o);
    }
  }
  getYielded() {
    return this.yielded;
  }
  addKnownPreimage(t) {
    this.preimages.set(I.sha256(t).toString("hex"), t);
  }
  addKnownList(t) {
    for (const r of t) {
      const o = c.concat([c.from([0]), r]);
      this.addKnownPreimage(o);
    }
    const n = new K(t.map((r) => Y(r)));
    this.roots.set(n.getRoot().toString("hex"), n);
  }
  addKnownMapping(t) {
    this.addKnownList(t.keys), this.addKnownList(t.values);
  }
  addKnownWalletPolicy(t) {
    this.addKnownPreimage(t.serialize()), this.addKnownList(t.keys.map((n) => c.from(n, "ascii"))), this.addKnownPreimage(c.from(t.descriptorTemplate));
  }
  execute(t) {
    if (t.length === 0)
      throw new Error("Unexpected empty command");
    const n = t[0], r = this.commands.get(n);
    if (!r)
      throw new Error(`Unexpected command code ${n}`);
    return r.execute(t);
  }
}
class ti {
  /**
   * @param keys Sorted list of (unhashed) keys
   * @param values values, in corresponding order as the keys, and of equal length
   */
  constructor(t, n) {
    p(this, "keys");
    p(this, "keysTree");
    p(this, "values");
    p(this, "valuesTree");
    if (t.length != n.length)
      throw new Error("keys and values should have the same length");
    for (let r = 0; r < t.length - 1; r++)
      if (t[r].toString("hex") >= t[r + 1].toString("hex"))
        throw new Error("keys must be in strictly increasing order");
    this.keys = t, this.keysTree = new K(t.map((r) => Y(r))), this.values = n, this.valuesTree = new K(n.map((r) => Y(r)));
  }
  commitment() {
    return c.concat([V(this.keys.length), this.keysTree.getRoot(), this.valuesTree.getRoot()]);
  }
}
class Q extends tn {
  constructor(n) {
    super();
    p(this, "globalMerkleMap");
    p(this, "inputMerkleMaps", []);
    p(this, "outputMerkleMaps", []);
    p(this, "inputMapCommitments");
    p(this, "outputMapCommitments");
    n.copy(this), this.globalMerkleMap = Q.createMerkleMap(this.globalMap);
    const r = this.getGlobalInputCount();
    if (this.inputMaps.length !== r)
      throw new Error(`Input map count ${this.inputMaps.length} != declared PSBT_GLOBAL_INPUT_COUNT ${r}`);
    for (let s = 0; s < r; s++) {
      const i = this.inputMaps[s];
      if (i === void 0)
        throw new Error(`Missing input map ${s}`);
      this.inputMerkleMaps.push(Q.createMerkleMap(i));
    }
    this.inputMapCommitments = this.inputMerkleMaps.map((s) => s.commitment());
    const o = this.getGlobalOutputCount();
    if (this.outputMaps.length !== o)
      throw new Error(`Output map count ${this.outputMaps.length} != declared PSBT_GLOBAL_OUTPUT_COUNT ${o}`);
    for (let s = 0; s < o; s++) {
      const i = this.outputMaps[s];
      if (i === void 0)
        throw new Error(`Missing output map ${s}`);
      this.outputMerkleMaps.push(Q.createMerkleMap(i));
    }
    this.outputMapCommitments = this.outputMerkleMaps.map((s) => s.commitment());
  }
  // These public functions are for MerkelizedPsbt.
  getGlobalSize() {
    return this.globalMap.size;
  }
  getGlobalKeysValuesRoot() {
    return this.globalMerkleMap.commitment();
  }
  static createMerkleMap(n) {
    const r = [...n.keys()].sort(), o = r.map((i) => {
      const a = n.get(i);
      if (!a)
        throw new Error("No value for key " + i);
      return a;
    }), s = r.map((i) => c.from(i, "hex"));
    return new ti(s, o);
  }
}
const ei = 2;
class ni {
  /**
   * Creates and instance of a wallet policy.
   * @param name an ascii string, up to 16 bytes long; it must be an empty string for default wallet policies
   * @param descriptorTemplate the wallet policy template
   * @param keys and array of the keys, with the key derivation information
   */
  constructor(t, n, r) {
    p(this, "name");
    p(this, "descriptorTemplate");
    p(this, "keys");
    this.name = t, this.descriptorTemplate = n, this.keys = r;
  }
  /**
   * Returns the unique 32-bytes id of this wallet policy.
   */
  getId() {
    return I.sha256(this.serialize());
  }
  /**
   * Serializes the wallet policy for transmission via the hardware wallet protocol.
   * @returns the serialized wallet policy
   */
  serialize() {
    const t = this.keys.map((o) => c.from(o, "ascii")), n = new K(t.map((o) => Y(o))), r = new L();
    return r.writeUInt8(ei), r.writeVarSlice(c.from(this.name, "ascii")), r.writeVarInt(this.descriptorTemplate.length), r.writeSlice(I.sha256(c.from(this.descriptorTemplate))), r.writeVarInt(this.keys.length), r.writeSlice(n.getRoot()), r.buffer();
  }
}
class an extends ni {
  constructor(t, n) {
    super("", t, [n]);
  }
}
const ri = 4, oi = 0, si = 1, cn = 32, ii = new Uint8Array(cn), ai = new Uint8Array(cn), ci = /^[0-9a-f]{64}$/, ui = /^(?:[0-9a-fA-F]{2})+$/;
function li(e, t) {
  const n = new K(e.inputMapCommitments.map((o) => Y(o))).getRoot(), r = new K(e.outputMapCommitments.map((o) => Y(o))).getRoot();
  return Uint8Array.from(
    c.concat([
      e.getGlobalKeysValuesRoot(),
      V(e.getGlobalInputCount()),
      n,
      V(e.getGlobalOutputCount()),
      r,
      c.from(t),
      // Derived apps have no registered policies: the hmac is all-zero for the
      // default policy too (`base:init_global_state.c:184-187`).
      c.from(ai)
    ])
  );
}
function hi(e) {
  return { cla: b, ins: ri, p1: oi, p2: si, data: e };
}
const pi = 0;
function fi(e, t) {
  for (const [n] of t.byInput) {
    const r = e.data.inputs[n].sighashType;
    if (r !== void 0 && r !== pi)
      throw new d(
        `input ${n} requests sighash type ${r}, but vault flows sign SIGHASH_DEFAULT only`
      );
  }
}
function di(e, t) {
  var n;
  for (const [r, o] of t.byInput) {
    const s = e.data.inputs[r];
    if (s.finalScriptWitness || s.finalScriptSig)
      throw new d(
        `input ${r} is already finalized and this round signs it — pass an unsigned PSBT`
      );
    if (o.kind === "tapscript") {
      if ((n = s.tapScriptSig) == null ? void 0 : n.some(
        (a) => a.pubkey.toString("hex") === o.expectedSignerXOnlyHex && o.expectedLeafHashHexes.has(a.leafHash.toString("hex"))
      ))
        throw new d(
          `input ${r} already carries a tapScriptSig for a (key, leaf) we sign — pass an unsigned PSBT`
        );
      continue;
    }
    if (s.tapKeySig)
      throw new d(
        `input ${r} already carries a tapKeySig and this round signs its keypath — pass an unsigned PSBT`
      );
  }
}
const un = /* @__PURE__ */ new WeakMap();
function Ei(e, t) {
  const n = { ...e };
  return un.set(n, t), n;
}
function ln(e) {
  const t = un.get(e);
  if (!t)
    throw new d("unrecognised prepared signing state — use prepareSignPsbt's return value");
  return t;
}
function gi(e) {
  const { psbtHex: t, depositorXOnlyHex: n, signInputIndexes: r, walletPolicy: o } = e;
  if (!ci.test(n))
    throw new d("depositorXOnlyHex must be 64 lowercase hex characters");
  let s;
  if (o !== void 0 && (s = new an(o.descriptorTemplate, o.keyInfo), s.getId().toString("hex") !== o.walletIdHex))
    throw new d("walletPolicy.walletIdHex does not match sha256 of the serialized policy");
  if (!ui.test(t))
    throw new d("psbtHex is not even-length hexadecimal");
  let i;
  try {
    i = A.fromHex(t);
  } catch (g) {
    throw new d(
      `PSBT rejected at parse (merge target): ${g instanceof Error ? g.message : String(g)}`
    );
  }
  const a = new tn();
  try {
    a.deserialize(c.from(t, "hex"));
  } catch (g) {
    throw new d(
      `PSBT rejected at parse: ${g instanceof Error ? g.message : String(g)}`
    );
  }
  let u, l;
  try {
    u = new Q(a), l = Yo({ psbt: u, depositorXOnlyHex: n, signInputIndexes: r });
  } catch (g) {
    throw g instanceof d ? g : new d(
      `PSBT rejected at preflight: ${g instanceof Error ? g.message : String(g)}`
    );
  }
  di(i, l), fi(i, l);
  const f = Xo(l), E = new Js(void 0, (g) => f.assertAndRecord(g));
  E.addKnownMapping(u.globalMerkleMap);
  for (const g of u.inputMerkleMaps)
    E.addKnownMapping(g);
  for (const g of u.outputMerkleMaps)
    E.addKnownMapping(g);
  E.addKnownList(u.inputMapCommitments), E.addKnownList(u.outputMapCommitments);
  const h = o ? c.from(o.walletIdHex, "hex") : ii;
  return s && E.addKnownWalletPolicy(s), Ei(
    { table: l, unsignedTxid: ct.fromBuffer(i.data.globalMap.unsignedTx.toBuffer()).getId() },
    {
      cdata: li(u, h),
      interpreter: E,
      collector: f,
      originalPsbtHex: t,
      signsUnderWalletPolicy: o !== void 0
    }
  );
}
const _i = 248, wi = 1, Ti = 0, mi = 0, Ii = 36864, Si = 57344;
async function Pi(e, t, n) {
  const { collector: r, interpreter: o, cdata: s } = ln(t), { table: i } = t;
  if (n.signal.aborted)
    throw new oe(r.yields.length);
  const a = hi(s);
  let u = a, l = await e(a), f = 0;
  for (; l.sw === Si; ) {
    let E;
    try {
      E = o.execute(c.from(l.data));
    } catch (h) {
      throw jr(h) ? h : Qr(h) ? new d(h.detail, at(r.yields)) : new d(
        `client command failed: ${h instanceof Error ? h.message : String(h)}`,
        at(r.yields)
      );
    }
    if (r.yields.length > f) {
      f = r.yields.length;
      const h = r.lastYield;
      if (h !== void 0 && n.onProgress !== void 0)
        try {
          n.onProgress({
            inputIndex: h.inputIndex,
            yieldedCount: f,
            expectedYieldCount: i.expectedYieldCount
          });
        } catch {
        }
    }
    if (n.signal.aborted)
      throw new oe(r.yields.length);
    u = { cla: _i, ins: wi, p1: Ti, p2: mi, data: E }, l = await e(u);
  }
  if (l.sw !== Ii) {
    const E = ze(l.sw, {
      ...n.appIdentity,
      ins: u.ins,
      p1: u.p1,
      // Only the initial APDU's refusal proves no round ran; a lock on a
      // CONTINUE leaves caps possibly committed, so it stays unproven.
      preDispatch: u === a
    });
    throw E === void 0 ? new d(
      `status word 0x${l.sw.toString(16)} escaped classification`,
      at(r.yields)
    ) : E;
  }
  return r.assertComplete(), r.yields;
}
function yi(e, t) {
  const n = A.fromHex(e);
  for (const r of t)
    r.kind === "tapscript" ? n.updateInput(r.inputIndex, {
      tapScriptSig: [
        {
          pubkey: c.from(r.signerXOnlyHex, "hex"),
          leafHash: c.from(r.leafHashHex, "hex"),
          signature: c.from(r.signature)
        }
      ]
    }) : n.updateInput(r.inputIndex, { tapKeySig: c.from(r.signature) });
  return n.toHex();
}
const Ae = /* @__PURE__ */ new WeakSet();
async function Ai(e, t, n) {
  const { originalPsbtHex: r, signsUnderWalletPolicy: o } = ln(t);
  if (Ae.has(t))
    throw new d(
      "prepared signing state was already used — call prepareSignPsbt again for a retry"
    );
  if ([...t.table.byInput.values()].some((u) => u.kind === "taproot-keypath") && !o)
    throw new d(
      "PSBT signs a key-path input but was prepared without a walletPolicy — the device would answer SW_OK with no signature"
    );
  Ae.add(t);
  const i = await Pi(e, t, n);
  let a;
  try {
    a = yi(r, i);
  } catch (u) {
    throw new d(
      `merge failed after signing: ${u instanceof Error ? u.message : String(u)}`,
      at(i)
    );
  }
  return { signedPsbtHex: a, yields: [...i] };
}
async function ji(e, t) {
  const { psbtHex: n, depositorXOnlyHex: r, signInputIndexes: o, ...s } = t, i = gi({ psbtHex: n, depositorXOnlyHex: r, signInputIndexes: o });
  return Ai(e, i, s);
}
const xe = "tr(@0/**)", be = 2147483647, xi = /^[0-9a-f]{8}$/;
function Qi(e) {
  const { masterFingerprintHex: t, coinType: n, accountIndex: r, accountXpub: o, bip32Versions: s } = e;
  if (!xi.test(t))
    throw new Error("masterFingerprintHex must be 8 lowercase hex characters");
  if (!Number.isInteger(n) || n < 0 || n > be || !Number.isInteger(r) || r < 0 || r > be)
    throw new Error("coinType and accountIndex must be non-negative integers in 0..0x7fffffff");
  try {
    dt.fromExtendedKey(o, s);
  } catch (u) {
    throw new Error(
      `accountXpub is not a valid extended key for this network: ${u instanceof Error ? u.message : String(u)}`
    );
  }
  const i = `[${t}/${ut}'/${n}'/${r}']${o}`, a = new an(xe, i).getId().toString("hex");
  return {
    descriptorTemplate: xe,
    keyInfo: i,
    walletIdHex: a,
    accountXpub: o,
    bip32Versions: s,
    keyOriginPath: [(x | ut) >>> 0, (x | n) >>> 0, (x | r) >>> 0],
    masterFingerprintHex: t
  };
}
export {
  _o as DEPOSIT_TERMS_REJECTED_ERROR_NAME,
  S as DepositTermsRejectedError,
  De as LEDGER_DEVICE_ERROR_NAME,
  He as LEDGER_DEVICE_LOCKED_ERROR_NAME,
  Ke as LEDGER_SIGN_PSBT_ABORTED_ERROR_NAME,
  Ve as LEDGER_SIGN_PSBT_INCOMPLETE_ERROR_NAME,
  Ge as LEDGER_SIGN_PSBT_PROTOCOL_ERROR_NAME,
  Be as LEDGER_USER_REFUSED_ERROR_NAME,
  Fe as LEDGER_YIELD_MISMATCH_ERROR_NAME,
  qr as LedgerDeviceError,
  Wr as LedgerDeviceLockedError,
  oe as LedgerSignPsbtAbortedError,
  zr as LedgerSignPsbtIncompleteError,
  d as LedgerSignPsbtProtocolError,
  Xr as LedgerUserRefusedError,
  y as LedgerYieldMismatchError,
  eo as SW_BAD_STATE,
  no as SW_CAP_EXCEEDED,
  Xe as SW_CLA_NOT_SUPPORTED,
  We as SW_INS_NOT_SUPPORTED,
  Mi as approveVaultIntent,
  Ki as assertDepositTermsDeviceCompatible,
  Cs as assertRefundPsbtSignable,
  Ci as augmentPsbtForDelegatedClaim,
  zi as augmentPsbtForReclaim,
  qi as augmentPsbtForRefund,
  Xi as augmentPsbtForWalletPolicy,
  Qi as buildDefaultTaprootPolicy,
  Wi as buildPopPsbtHex,
  Zn as classifyDelegatedClaimPsbt,
  Gs as classifyReclaimPsbt,
  vs as classifyRefundPsbt,
  ta as closeDmk,
  ea as connectDmkSession,
  Gi as createDmkApduSender,
  ao as createDmkRawApduSender,
  Ni as deriveContextHash,
  Yi as deriveReceiveXOnlyHex,
  na as disconnectDmkSession,
  Ar as encodeIntentGroup,
  yr as encodeIntentScalars,
  xr as encodeKeyBatches,
  Kr as getExtendedPublicKey,
  $i as getMasterFingerprintHex,
  Ui as getVaultState,
  ki as getXOnlyPublicKeyHex,
  Li as intentFingerprint,
  Hi as isLedgerDeviceError,
  Di as isLedgerDeviceLockedError,
  Vi as isLedgerSignPsbtAbortedError,
  Fi as isLedgerSignPsbtIncompleteError,
  Qr as isLedgerSignPsbtProtocolError,
  Bi as isLedgerUserRefusedError,
  jr as isLedgerYieldMismatchError,
  ra as isSessionAlive,
  gi as prepareSignPsbt,
  oa as refreshSessionApp,
  Ai as signPreparedVaultPsbt,
  ji as signVaultPsbt
};
//# sourceMappingURL=index.js.map
